<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Report_users"
    :submit="submit" :status="status">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider ref="sender_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.sender_id" prepend-inner-icon="fas fa-user"
                  :items="users" item-text="full_name" item-value="id" label="Usuario"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="receiver_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.receiver_id" prepend-inner-icon="fas fa-user"
                  :items="users" item-text="full_name" item-value="id" label="Usuario Reportado"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <label>Motivo</label>
              <ValidationProvider ref="reason" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.reason" solo rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="enabled" rules="" v-slot="{ errors }">
                <v-checkbox v-model="data.enabled" label="Inhabilitar usuario"></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  async created() {
    const self = this;
    await self.$store.dispatch('Users/getListAll', { enabled: false });

    if (this.$route.params.id) {
      let report_user = await self.$store.dispatch('Report_users/getListAll', { id: this.$route.params.id });
      this.data.enabled = report_user[0].receiver_id.enabled;
    }
  },
  data() {
    return {
      storeName: "Report_users",
      title: "Usuario Reportado",
      show1: false,
      user_enabled: '',
      data: {
        sender_id: "",
        receiver_id: "",
        reason: "",
        enabled: ''
      }
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Report_users.status,
      users: (state) => state.Users.list,
    }),
  },
  watch: {

  },
  methods: {

  },
};
</script>
